// Public (anonymous) news site endpoint — no auth required.
export const PUBLIC_NOTICIAS_PATH = 'public/noticias';

// Admin CMS endpoint — authenticated, gated by noticias:* permissions.
export const NOTICIAS_ADMIN_PATH = 'admin/noticias';
